export const intakeTrend = [
  { month: 'Sep 25', Mega: 1, Major: 2, International: 4 },
  { month: 'Oct 25', Mega: 0, Major: 3, International: 5 },
  { month: 'Nov 25', Mega: 1, Major: 2, International: 6 },
  { month: 'Dec 25', Mega: 0, Major: 1, International: 3 },
  { month: 'Jan 26', Mega: 2, Major: 3, International: 7 },
  { month: 'Feb 26', Mega: 1, Major: 4, International: 8 },
  { month: 'Mar 26', Mega: 1, Major: 3, International: 9 },
  { month: 'Apr 26', Mega: 0, Major: 5, International: 11 },
  { month: 'May 26', Mega: 2, Major: 4, International: 10 },
  { month: 'Jun 26', Mega: 1, Major: 6, International: 12 },
  { month: 'Jul 26', Mega: 3, Major: 5, International: 14 },
  { month: 'Aug 26', Mega: 2, Major: 4, International: 9 }
]

export const intakeSummary = {
  trailingTwelveMonths: 160,
  yearOnYearChange: 23,
  approvalRate: 71,
  meanDecisionDays: 24
}
